import { cx } from "../../lib/index.js";
import { SubmitIcon } from "./icons.js";
export function createAutocompleteSuggestionComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteSuggestion(userProps) {
    var children = userProps.children,
      onSelect = userProps.onSelect,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames;
    return createElement("div", {
      onClick: onSelect,
      className: cx('ais-AutocompleteItemWrapper', 'ais-AutocompleteSuggestionWrapper', classNames.root)
    }, createElement("div", {
      className: cx('ais-AutocompleteItemContent', 'ais-AutocompleteSuggestionItemContent', classNames.content)
    }, createElement("div", {
      className: cx('ais-AutocompleteItemIcon', 'ais-AutocompleteSuggestionItemIcon', classNames.content)
    }, createElement(SubmitIcon, {
      createElement: createElement
    })), createElement("div", {
      className: cx('ais-AutocompleteItemContentBody', 'ais-AutocompleteSuggestionItemContentBody', classNames.content)
    }, children)));
  };
}